
import ResetPasswordForm from "../../components/common/ResetPassword";

const ResetPassword = () => {
    return (
        <ResetPasswordForm />
    )
}

export default ResetPassword;